export default __webpack_public_path__ + "static/ActaAgate-Book-c33b7abfe1d0325889928b0c2f9fde1f.woff";